import { get } from "@/services/axiosUitils";
import {
  CapitalMarketNewsResponse,
  CapitalMarketNewsItem,
} from "@/utils/types/news";

const basePath = "/screener/capital-market-news/";

class NewsService {
  /**
   * Get paginated capital market news
   * @param page - Page number (default: 1)
   * @param pageSize - Number of items per page (default: 20)
   * @returns Paginated news response
   */
  getCapitalMarketNews = async (
    page: number = 1,
    pageSize: number = 20
  ): Promise<CapitalMarketNewsResponse> => {
    return await get<CapitalMarketNewsResponse>(
      `${basePath}?page=${page}&page_size=${pageSize}`
    );
  };

  /**
   * Get all news items by fetching all pages
   * @param pageSize - Number of items per page (default: 20)
   * @returns All news items
   */
  getAllCapitalMarketNews = async (
    pageSize: number = 20
  ): Promise<CapitalMarketNewsItem[]> => {
    let allResults: CapitalMarketNewsItem[] = [];
    let currentPage = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await this.getCapitalMarketNews(currentPage, pageSize);
      if (response?.results) {
        allResults = [...allResults, ...response.results];
        hasMore = response.next !== null;
        currentPage++;
      } else {
        hasMore = false;
      }
    }

    return allResults;
  };
}

export default new NewsService();
